import type { BrandingConfig, InstanceConfig } from '../config/types';
import type { AuthUser } from '../auth/keycloak';
import { useAuth } from '../auth/AuthProvider';

export default function Header({
  branding,
  user,
  instance
}: {
  branding: BrandingConfig;
  user: AuthUser | null;
  instance: InstanceConfig;
}) {
  const { logout, keycloak } = useAuth();
  const showLogout = keycloak !== null && user !== null;

  return (
    <header className="header">
      <div className="header-brand">
        <img src={branding.logoUrl} alt={branding.title} className="header-logo" />
        <div>
          <div className="header-title">{branding.title}</div>
          {branding.tagline && <div className="header-tagline">{branding.tagline}</div>}
        </div>
      </div>
      <div className="header-meta">
        <span className={`instance-badge instance-${instance.type}`}>
          {instance.type} · {instance.tier}
        </span>
        {user && user.id !== 'anon' && (
          <span className="user-name">{user.name ?? user.username}</span>
        )}
        {showLogout && (
          <button onClick={logout} className="logout-btn">Sign out</button>
        )}
      </div>
    </header>
  );
}
